import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import CreateAutoOLTComponent from "../superCOO/CreateAutoOLT";

const ModalForNewAutoOLTCreation: React.FC<NewOLTModalProp> = ({
  handleClose,
  show,
  intPkCompanyID,
  companyName,
}) => {
  const handleApiResponse = (isSuccess: boolean) => {
    console.log({ isSuccess });
    if (isSuccess === true) {
      handleClose(true);
    }
  };
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        show={show}
        onHide={() => {
          handleClose(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> New OLT</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateAutoOLTComponent
            companyName={companyName}
            intPkCompanyID={intPkCompanyID}
            handleApiResponse={handleApiResponse}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ModalForNewAutoOLTCreation;
